export default "__VITE_ASSET__BlifeV5M__"